import { createContext, useContext, useState } from "react";

const GlobalLoaderContext = createContext();

export const useGlobalLoader = () => useContext(GlobalLoaderContext);

export const GlobalLoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState("Loading...");
  const [status, setStatus] = useState("loading"); // loading | success

  const showLoader = (message = "Loading...") => {
    setText(message);
    setStatus("loading");
    setLoading(true);
  };

  const showSuccess = (message = "Success!") => {
    setText(message);
    setStatus("success");

    // auto hide after animation
    setTimeout(() => {
      setLoading(false);
      setStatus("loading");
      setText("Loading...");
    }, 2000); // match with animation duration
  };

  const hideLoader = () => {
    setLoading(false);
    setStatus("loading");
    setText("Loading...");
  };

  return (
    <GlobalLoaderContext.Provider
      value={{ showLoader, hideLoader, showSuccess }}
    >
      {children}

      {/* GLOBAL OVERLAY */}
      {loading && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl px-10 py-8 flex flex-col items-center gap-4 w-[320px] animate-in fade-in zoom-in-95 duration-300">
            {/* CIRCLE */}
            <div className="relative w-20 h-20 flex items-center justify-center">
              {/* Background Circle */}
              <div className="absolute inset-0 rounded-full border-4 border-slate-200"></div>

              {/* Loading Spinner */}
              {status === "loading" && (
                <div className="absolute inset-0 rounded-full border-4 border-blue-600 border-t-transparent animate-spin"></div>
              )}

              {/* Success Check */}
              {status === "success" && (
                <svg
                  className="w-12 h-12 text-green-500 animate-scale-in"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M5 13l4 4L19 7"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="animate-draw"
                  />
                </svg>
              )}
            </div>

            {/* TITLE */}
            <h2 className="text-xl font-semibold text-slate-800">
              {status === "loading" ? "Processing..." : "Success!"}
            </h2>

            {/* DESCRIPTION */}
            <p className="text-sm text-slate-500 text-center">
              {status === "loading" ? text : text}
              {/* : "Client has been successfully updated."} */}
            </p>

            {/* BUTTON (optional, only on success) */}
            {status === "success" && (
              <button
                onClick={hideLoader}
                className="mt-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-semibold transition"
              >
                OK
              </button>
            )}
          </div>
        </div>
      )}
    </GlobalLoaderContext.Provider>
  );
};

export default GlobalLoaderProvider;
